var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.globalBudgetAmount !== null
        ? _c(
            "div",
            {
              staticClass: "pl-2",
              staticStyle: {
                "margin-top": "-60px",
                height: "60px",
                "padding-top": "7px"
              }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-progress-circular",
                    {
                      class: _vm.classByPercentage(
                        _vm.globalUtilizationPercentage
                      ),
                      attrs: {
                        rotate: -90,
                        size: 75,
                        width: 15,
                        value: _vm.globalUtilizationPercentage
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.globalUtilizationPercentage) + "% "
                      )
                    ]
                  ),
                  _c(
                    "v-row",
                    { attrs: { "align-content": "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ml-3 pb-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("booking.globalBudgetUtilization")
                                ) + ": "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ml-3 pb-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "large"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: _vm.classByPercentage(
                                    _vm.globalUtilizationPercentage
                                  ),
                                  staticStyle: {
                                    color: "#44d3af",
                                    "font-size": "x-large"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.globalBudgetUtilization) +
                                      " PLN "
                                  )
                                ]
                              ),
                              _vm._v(
                                " / " + _vm._s(_vm.globalBudgetAmount) + " PLN"
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticStyle: { "margin-top": "30px" } }, [
        _c("h1", { staticStyle: { display: "inline" } }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm.typeBudgetAmount !== null
          ? _c(
              "span",
              { staticClass: "mx-4", staticStyle: { "font-size": "medium" } },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      position: "relative",
                      bottom: "7px"
                    }
                  },
                  [
                    _c("v-progress-circular", {
                      class: _vm.classByPercentage(
                        _vm.typeUtilizationPercentage
                      ),
                      attrs: {
                        rotate: -90,
                        size: 35,
                        width: 8,
                        value: _vm.typeUtilizationPercentage
                      }
                    })
                  ],
                  1
                ),
                _c("span", { staticClass: "pb-3" }, [
                  _vm._v(" " + _vm._s(_vm.typeUtilizationPercentage) + "% "),
                  _c(
                    "span",
                    {
                      staticClass: "ml-1",
                      class: _vm.classByPercentage(
                        _vm.typeUtilizationPercentage
                      ),
                      staticStyle: { "font-size": "x-large" }
                    },
                    [_vm._v(_vm._s(_vm.typeBudgetUtilization) + " PLN")]
                  ),
                  _vm._v(" / " + _vm._s(_vm.typeBudgetAmount) + " PLN ")
                ]),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "lighter",
                      "font-size": "small"
                    }
                  },
                  [
                    _vm._v(
                      "(" +
                        _vm._s(_vm.$t("booking.typeBudgetUtilization")) +
                        ")"
                    )
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _c("booking-menu")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }